// extracted by mini-css-extract-plugin
export default {"link":"HeadPage_link__GnBiW","lastLink":"HeadPage_lastLink__lXsuo"};